import React from 'react'
import algolia from 'services/algolia'
import WhiteHero from 'components/shared/WhiteHero'
import { slugify } from 'src/lib/slugify'
import { buildStaticPaths } from 'services/api'
import BackToList from 'components/shared/BackToList'

import SliceManager from 'components/shared/SliceManager'
import { revalidating } from 'src/lib/staticProps'

const algoliaIndex = algolia('showcases')

const Showcase = ({ pageData }) => {
  const {
    title,
    description,
    frontend,
    url,
    image,
    made_by,
    made_by_url,
    categories,
  } = pageData?.data
  const whiteHero = {
    topRightImage: {
      href: null,
      media: {
        data: {
          attributes: {
            url: image,
          },
        },
      },
      lottieAnimation: null,
    },

    intro: {
      theme: 'purple',
      label: `Built with Strapi ${frontend ? `, ${frontend.join(', ')}` : ''}`,
      title: title,
      text: `${
        categories ? `*${categories.join(', ')}*\n\n` : ''
      }${description} ${
        made_by ? `\n\n Made by [${made_by}](${made_by_url})` : ''
      }`,
      button: [
        {
          theme: 'blue',
          link: {
            href: url,
            target: '_blank',
            text: 'Browse website',
            summary: null,
            icons: [],
          },
        },
        {
          theme: 'white',
          link: {
            href: 'https://strapi.io/contact-sales',
            target: null,
            text: 'Talk to sales',
            summary: null,
          },
        },
      ],
      smallTextWithLink: [],
      newsWithLink: null,
    },
  }
  const caseStudyCard = {
    id: 81,
    __component: 'slices.case-study-card',
    buttonText: 'Read Kyivstar case study',
    triangleImage: {
      id: 5725,
      href: null,
      media: {
        data: {
          id: 3237,
          attributes: {
            name: 'kyivstar',
            alternativeText: '',
            caption: '',
            width: 958,
            height: 958,
            formats: {
              small: {
                ext: '.jpg',
                url: '/uploads/small_taryf_8dda6d616e.jpg',
                hash: 'small_taryf_8dda6d616e',
                mime: 'image/png',
                name: 'small_kyivstar',
                path: null,
                size: 464.47,
                width: 500,
                height: 500,
              },
              medium: {
                ext: '.jpg',
                url: '/uploads/medium_taryf_8dda6d616e.jpg',
                hash: 'medium_taryf_8dda6d616e',
                mime: 'image/png',
                name: 'medium_kyivstar',
                path: null,
                size: 999.01,
                width: 750,
                height: 750,
              },
              thumbnail: {
                ext: '.jpg',
                url: '/uploads/thumbnail_taryf_8dda6d616e.jpg',
                hash: 'thumbnail_taryf_8dda6d616e',
                mime: 'image/png',
                name: 'thumbnail_kyivstar',
                path: null,
                size: 53.07,
                width: 156,
                height: 156,
              },
            },
            hash: 'taryf_8dda6d616e',
            ext: '.jpg',
            mime: 'image/png',
            size: 1326.99,
            url: '/uploads/taryf_8dda6d616e.jpg',
            previewUrl: null,
            provider: 'local',
            provider_metadata: null,
            createdAt: '2022-04-15T17:02:06.114Z',
            updatedAt: '2022-11-22T15:41:58.258Z',
          },
        },
      },
      lottieAnimation: null,
    },
    card: {
      title:
        'Kyivstar uses Strapi for a website and mobile app with 10 million monthly active users',
      label: 'Kyivstar',
      logo: '/uploads/Kyivstar_Telesens_6fb8afe1f2.png',
      link: {
        text: 'Read Kyivstar case study',
        href: '/user-stories/kyivstar',
      },
    },
  }
  const brandWithIntro = {
    id: 1,
    __component: 'slices.brands-with-intro',
    gradientHeader: null,
    intro: {
      id: 156,
      theme: 'blue',
      label: 'Trusted by innovative companies',
      title: null,
      text: null,
      cliContent: null,
      button: [],
      smallTextWithLink: [],
      newsWithLink: null,
    },
    brands: [
      {
        id: 13,
        link: {
          id: 460,
          href: 'https://www.ibm.com/thought-leadership/institute-business-value',
          target: '_blank',
          text: null,
          summary: null,
          icons: [],
        },
        logo: {
          id: 946,
          href: null,
          media: {
            data: {
              id: 1215,
              attributes: {
                name: 'ibm',
                alternativeText: '',
                caption: '',
                width: 70,
                height: 28,
                formats: null,
                hash: 'ibm_1f63f8c1a8_c88e8d653c',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 2.36,
                url: '/uploads/ibm_1f63f8c1a8_c88e8d653c.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T17:54:37.499Z',
                updatedAt: '2022-11-09T09:40:28.741Z',
              },
            },
          },
          lottieAnimation: null,
        },
        greyLogo: {
          id: 947,
          href: null,
          media: {
            data: {
              id: 1217,
              attributes: {
                name: 'ibm-grey',
                alternativeText: '',
                caption: '',
                width: 70,
                height: 28,
                formats: {},
                hash: 'ibm-grey_75e5c3ba80',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 2.36,
                url: '/uploads/ibm-grey_75e5c3ba80.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T17:55:29.556Z',
                updatedAt: '2020-07-21T18:01:56.760Z',
              },
            },
          },
          lottieAnimation: null,
        },
      },
      {
        id: 14,
        link: null,
        logo: {
          id: 948,
          href: null,
          media: {
            data: {
              id: 1218,
              attributes: {
                name: 'walmart-grey',
                alternativeText: '',
                caption: '',
                width: 116,
                height: 29,
                formats: {},
                hash: 'walmart-grey_1d11b0b513',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 5.47,
                url: '/uploads/walmart-grey_1d11b0b513.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T17:57:59.641Z',
                updatedAt: '2020-07-21T18:02:59.958Z',
              },
            },
          },
          lottieAnimation: null,
        },
        greyLogo: null,
      },
      {
        id: 15,
        link: {
          id: 461,
          href: 'https://esc.gsfc.nasa.gov/',
          target: '_blank',
          text: null,
          summary: null,
          icons: [],
        },
        logo: {
          id: 949,
          href: null,
          media: {
            data: {
              id: 1219,
              attributes: {
                name: 'nasa',
                alternativeText: '',
                caption: '',
                width: 101,
                height: 28,
                formats: {},
                hash: 'nasa_cf7e56179f',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 2.6,
                url: '/uploads/nasa_cf7e56179f.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T17:58:56.846Z',
                updatedAt: '2020-07-21T18:03:44.460Z',
              },
            },
          },
          lottieAnimation: null,
        },
        greyLogo: {
          id: 952,
          href: null,
          media: {
            data: {
              id: 1220,
              attributes: {
                name: 'nasa-grey',
                alternativeText: '',
                caption: '',
                width: 101,
                height: 28,
                formats: {},
                hash: 'nasa-grey_4b2d4f50a5',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 2.6,
                url: '/uploads/nasa-grey_4b2d4f50a5.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T17:59:27.832Z',
                updatedAt: '2020-07-21T18:05:13.553Z',
              },
            },
          },
          lottieAnimation: null,
        },
      },
      {
        id: 16,
        link: {
          id: 462,
          href: '/user-stories/societe-generale-e-training-platform',
          target: null,
          text: null,
          summary: null,
          icons: [],
        },
        logo: {
          id: 950,
          href: null,
          media: {
            data: {
              id: 1221,
              attributes: {
                name: 'societe-generale',
                alternativeText: '',
                caption: '',
                width: 120,
                height: 24,
                formats: {},
                hash: 'societe-generale_980651b2b8',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 4.09,
                url: '/uploads/societe-generale_980651b2b8.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T18:00:11.652Z',
                updatedAt: '2020-07-21T18:05:59.644Z',
              },
            },
          },
          lottieAnimation: null,
        },
        greyLogo: {
          id: 953,
          href: null,
          media: {
            data: {
              id: 1222,
              attributes: {
                name: 'societe-generale-grey',
                alternativeText: '',
                caption: '',
                width: 120,
                height: 24,
                formats: {},
                hash: 'societe-generale-grey_c6c17564a4',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 4.12,
                url: '/uploads/societe-generale-grey_c6c17564a4.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T18:00:36.841Z',
                updatedAt: '2020-07-21T18:08:12.244Z',
              },
            },
          },
          lottieAnimation: null,
        },
      },
      {
        id: 17,
        link: {
          id: 463,
          href: '/user-stories/delivery-hero',
          target: null,
          text: null,
          summary: null,
          icons: [],
        },
        logo: {
          id: 951,
          href: null,
          media: {
            data: {
              id: 1223,
              attributes: {
                name: 'delivery-hero-horizontal',
                alternativeText: '',
                caption: '',
                width: 127,
                height: 20,
                formats: {},
                hash: 'delivery-hero-horizontal_c0fbcabf03',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 4.49,
                url: '/uploads/delivery-hero-horizontal_c0fbcabf03.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T18:01:09.939Z',
                updatedAt: '2020-07-21T18:09:05.630Z',
              },
            },
          },
          lottieAnimation: null,
        },
        greyLogo: {
          id: 954,
          href: null,
          media: {
            data: {
              id: 1224,
              attributes: {
                name: 'delivery-hero-grey',
                alternativeText: '',
                caption: '',
                width: 127,
                height: 20,
                formats: {},
                hash: 'delivery-hero-grey_658ccbd1d1',
                ext: '.svg',
                mime: 'image/svg+xml',
                size: 4.49,
                url: '/uploads/delivery-hero-grey_658ccbd1d1.svg',
                previewUrl: null,
                provider: 'local',
                provider_metadata: null,
                createdAt: '2020-07-21T18:01:32.766Z',
                updatedAt: '2020-07-21T18:09:25.236Z',
              },
            },
          },
          lottieAnimation: null,
        },
      },
    ],
  }
  return (
    <>
      <div className="container">
        <BackToList
          text="Back to showcases"
          url={'/showcases'}
        />
        {whiteHero && <WhiteHero {...whiteHero} />}
        <SliceManager slices={[brandWithIntro, caseStudyCard]} />
      </div>
    </>
  )
}

export async function getStaticPaths() {
  const showcases = await algoliaIndex.search('', {
    hitsPerPage: 1000,
  })

  const data = showcases?.hits.map((item) => {
    return { slug: slugify(item?.slug) }
  })
  return buildStaticPaths(data, 'showcases')
}

export async function getStaticProps({ params }) {
  const res = await algoliaIndex.search(slugify(params?.slug), {
    hitsPerPage: 1,
  })

  if (res?.nbHits < 1) {
    return {
      props: {},
      notFound: true,
    }
  }

  const data = res?.hits?.[0]

  return revalidating({
    props: {
      pageData: {
        data,
        seo: {
          metaTitle: `${data?.title} - Built with Strapi, ${
            data?.frontend && data?.frontend.join(', ')
          } | Showcase`,
          metaDescription: `${
            data?.title
          } showcases an innovative solution created by ${
            data?.made_by
          } using ${
            data?.frontend && data?.frontend.join(', ')
          }. Built with Strapi, this project advances ${data?.description.substring(
            0,
            70
          )}...`,
        },
      },
    },
  })
}

export default Showcase
